module.exports = "https://web-assets.ifttt.com/packs/media/images/logo-ifttt-1975319a.svg";